export default __webpack_public_path__ + "static/media/img-0299-brazil-full-face.f65866ad.png";